module.exports = __webpack_public_path__ + "static/img/cont2201.cb4d0e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2201.jpg
// module id = Dn0P
// module chunks = 0